import React, { ReactNode } from 'react'

import { IconFilter } from '@avantstay/backoffice-vectors'

import * as S from './FilterIndicator.styles'
import { FilterPositionProps } from './FilterIndicator.styles'

interface Props extends FilterPositionProps {
  showFilter: boolean
  filterComponent: ReactNode
  onToggleFilter: (value: boolean) => void
  isActiveFilter?: boolean
  activeFiltersLength?: number
  shouldHideFloatingContainer?: boolean
}

export const FilterIndicator = ({
  activeFiltersLength,
  isActiveFilter,
  showFilter,
  filterComponent,
  onToggleFilter,
  right,
  left,
  shouldHideFloatingContainer = false,
}: Props): JSX.Element => {
  const filterHasLength = activeFiltersLength ? activeFiltersLength > 0 : false

  window.addEventListener('resize', showFilter ? () => onToggleFilter(false) : () => null)

  return (
    <S.FilterContainer>
      <S.IconWrapper
        onClick={() => onToggleFilter(true)}
        isFilterActive={isActiveFilter || filterHasLength || showFilter}
      >
        <IconFilter />

        {filterHasLength && (
          <S.ActiveFilterIndicator>{activeFiltersLength}</S.ActiveFilterIndicator>
        )}
      </S.IconWrapper>

      <S.FloatingContainer
        open={showFilter}
        onClickOut={() => onToggleFilter(false)}
        placement="bottom-end"
        right={right}
        left={left}
        hideFloatingContainer={shouldHideFloatingContainer}
        className="floating-container"
      >
        {filterComponent}
      </S.FloatingContainer>
    </S.FilterContainer>
  )
}
